import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=5eb9c372&"
import script from "./reason.vue?vue&type=script&lang=ts&"
export * from "./reason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports